const body = document.body;
const html = document.documentElement;
const dHeight = Math.max(
	body.scrollHeight,
	body.offsetHeight,
	html.clientHeight,
	html.scrollHeight,
	html.offsetHeight
);

window.addEventListener('scroll', ucgParallax);

function ucgParallax() {
	const wHeight = window.innerHeight;
	const wTDRatio = wHeight / dHeight;
	const pages = dHeight / wHeight;
	const ups = document.querySelectorAll('.ucg-parallax');
	let scroll = window.scrollY;
	let innerScroll = Math.floor(scroll % wHeight);
	let increase = (wTDRatio * scroll) / pages;

	for (let i = 0; i < ups.length; i++) {
		const up = ups[i];
		const rect = up.getBoundingClientRect();
		let top = rect.top;

		if (top < wHeight) {
			let percent = ((wHeight - top) / wHeight) * 100;

			if (up.classList.contains('y10')) {
				let position = percent * -1;
				up.style.transform = 'translateY(' + position + 'px)';
			}

			if (up.classList.contains('y20')) {
				let position = percent * -2;
				up.style.transform = 'translateY(' + position + 'px)';
			}

			if (up.classList.contains('y30')) {
				let position = percent * -3;
				up.style.transform = 'translateY(' + position + 'px)';
			}

			if (up.classList.contains('y-10')) {
				let position = percent * 1;
				up.style.transform = 'translateY(' + position + 'px)';
			}

			if (up.classList.contains('y-20')) {
				let position = percent * 2;
				up.style.transform = 'translateY(' + position + 'px)';
			}

			if (up.classList.contains('y-30')) {
				let position = percent * 2;
				up.style.transform = 'translateY(' + position + 'px)';
			}
		}
	}
}
